import { useEffect, useState } from 'react';

const links = [
  { href: '#feed', label: '实时速报' },
  { href: '#hot', label: '全网热榜' },
  { href: '#channels', label: '栏目频道' },
  { href: '#timeline', label: '事件脉络' },
  { href: '#faq', label: '吃瓜指南' },
  { href: '#about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/80' : 'bg-background-50/60'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="看料站 首页">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary-500 font-heading text-xl text-background-50">
            料
          </span>
          <span className="font-heading text-2xl leading-none text-foreground-950">看料站</span>
          <span className="ml-1 inline-flex items-center gap-1.5 rounded-full bg-accent-50 px-2 py-0.5 text-[11px] font-semibold text-accent-700 ring-1 ring-accent-200">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500 animate-livepulse" />
            LIVE 实时
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#feed"
            className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            开始追更
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 place-items-center rounded-lg text-foreground-900 hover:bg-background-100 md:hidden"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'} style={{ fontSize: 22 }} />
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1 pt-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#feed"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              开始追更
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}